import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'Al confirmar el pago recibís un email con el enlace de descarga directa. Acceso inmediato a los 20 archivos PDF.'
  }, {
    q: '¿Sirve si soy profe nuevo o si tengo experiencia?',
    a: 'Sí para los dos casos. Si sos nuevo, el material te da estructura inmediata. Si tenés experiencia, te ahorra el tiempo de crear lo que ya sabés que funciona.'
  }, {
    q: '¿Los 6 Bonus están en las dos opciones?',
    a: 'Sí. Los 6 Bonus estratégicos están incluidos en el Pack Profesional y en el Megapack Elite sin costo adicional.'
  }, {
    q: '¿Qué diferencia hay con los libros de texto tradicionales?',
    a: 'Los libros tradicionales están hechos en Italia para alumnos europeos. Italiano 360 está diseñado para el alumno y el docente argentino. Contexto local, referencias culturales locales, formato A4 imprimible y ejercicios graficados que funcionan en el aula de hoy.'
  }, {
    q: '¿Sirve para clases online?',
    a: 'Totalmente. Los PDFs están optimizados para compartir pantalla en Zoom o Google Meet con total claridad visual.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Garantía total de 7 días. Si no es lo que esperabas, escribinos y te devolvemos el 100% sin preguntas.'
  }, {
    q: '¿Vale la pena el Megapack Elite si ya planifico bien mis clases?',
    a: 'Si ya planificás bien, el Megapack Elite te da dos cosas que el pack básico no tiene: una nueva fuente de ingresos (Método Viajero) y la recuperación de 10 horas mensuales que hoy perdés corrigiendo (Corrección Pro). Por $9.000 de diferencia, la respuesta es sí.'
  }, {
    q: '¿Puedo pagar con tarjeta de crédito?',
    a: 'Sí. Tarjeta de crédito/débito, transferencia bancaria y Mercado Pago.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-[#FAF6EE]" data-id="element-98">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
        <div className="text-center mb-12" data-id="element-100">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1F1A17]" data-id="element-101">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-102">
          {faqs.map((faq, i) => <div key={i} className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-103">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-104">
                <span className="font-bold text-[#1F1A17] pr-8" data-id="element-105">{faq.q}</span>
                {openIndex === i ? <ChevronUp className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-106" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-107" />}
              </button>

              {openIndex === i && <div className="px-6 pb-4 text-gray-600 leading-relaxed" data-id="element-108">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}